import React from "react";
import "./CategoryDetailMenu.css";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { formatPage } from "../../utils/formatPage";
import categoryData from "../../api/categories";

const CategoryDetailMenu = ({ subcategories }) => {
  const findParentCategory = (subcategoryName) => {
    const parentCategory = categoryData.category.find((cat) =>
      cat.subcategories.some((sub) => sub.name === subcategoryName)
    );
    return parentCategory ? parentCategory.categoryname : "Unknown";
  };

  return (
    <div className="d-flex justify-content-center">
      <Swiper
        spaceBetween={10}
        slidesPerView="auto"
        pagination={{ clickable: true }}
        navigation={true}
        modules={[Pagination]}
        className="mySwiper"
      >
        {subcategories.map((subcategory) => (
          <SwiperSlide
            key={subcategory.id}
            style={{ width: "200px", height: "250px" }}
            className="d-flex justify-content-center mt-5 "
          >
            <div className="card mt-3 p-3 border-1">
              <a
                href={`/${formatPage(
                  findParentCategory(subcategory.name)
                )}/${formatPage(subcategory.name)}`}
                className="text-decoration-none"
              >
                <img
                  src={subcategory.image}
                  className="card-img-top w-100 rounded-0"
                  alt={subcategory.name}
                />
                <div className="card-body text-center p-2">
                  <p className="card-title titlebtn fs-6 text-dark mb-0">
                    {subcategory.name}
                  </p>
                </div>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CategoryDetailMenu;
